export const imgBrigida = {
    src: 'images/brigida.jpg',
    alt: 'Brigida Figueira, a santinha de Angustura',
    text: 'Último retrato da Bidinha, 1930, em uma Estação de Águas medicinais.'
};
